var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.PanelChooserMobile = new Class({
    Implements: [Options, Events],
    element: null,
    current_panel: 1,
    prev_el: null,
    next_el: null,
    panel_dots: null,
    options: {
        container_id: "header",
        current_panel_update_event: 'update',
        panel_chooser_id: "mobile_panel_chooser",
        max_panels: 1,
        min_panels: 1
    },
    initialize: function (element, options) {
        this.setOptions(options);
        if (!element) {
            element = new Element('div', {id: this.options.panel_chooser_id}).inject(document.id(this.options.container_id));
        }
        var chooser = element.retrieve('panel_chooser');
        if (chooser) {
            return chooser;
        }
        this.element = element;
        this.draw();
        this.element.store('panel_chooser', this);
    },
    draw: function () {
        //<div id="mobile_panel_chooser"><span class="chooser_arrow prev inactive">&laquo;</span><span class="chooser_arrow next">&raquo;</span></div>
        if (!this.panel_dots) {
            this.panel_dots = new OCS.WxBriefing.Classes.PanelChooserDots();
            this.panel_dots.addEvent(this.panel_dots.options.dot_click_event, this.on_dot_click.bind(this));
        }
        if (!this.prev_el) {
            this.prev_el = new Element('span', {'class': "chooser_arrow prev", 'text': "\xAB"}).inject(this.element);
            this.prev_el.addEvent('click', this.on_prev_click.bind(this));
        }
        if (!this.next_el) {
            this.next_el = new Element('span', {'class': "chooser_arrow next", 'text': "\xBB"}).inject(this.element);
            this.next_el.addEvent('click', this.on_next_click.bind(this));
        }
        var max = this.options.max_panels;
        var min = this.options.min_panels;
        var current = this.current_panel;
        this.panel_dots.set_number_of_dots(max);
        this.panel_dots.set_active_panel_number(current);
        if (current === max) {
            this.next_el.addClass('inactive');
        }
        if (current < max) {
            this.next_el.removeClass('inactive');
        }
        if (current > min) {
            this.prev_el.removeClass('inactive');
        }
        if (current === min) {
            this.prev_el.addClass('inactive');
        }
    },
    on_dot_click: function (event) {
        this.set_current_panel(event.target.get('data-panel_number'));
    },
    on_prev_click: function (event) {
        this.set_current_panel(this.current_panel-1);
    },
    on_next_click: function (event) {
        this.set_current_panel(this.current_panel+1);
    },
    set_current_panel: function (current) {
        if (this.current_panel !== current && this.current_panel <= this.options.max_panels && this.current_panel >= this.options.min_panels) {
            this.current_panel = current;
            this.draw();
            this.fireEvent(this.options.current_panel_update_event, current);
        }
    },
    set_max_panels: function (max) {
        if (this.options.max_panels !== max) {
            this.options.max_panels = max;
            if (this.current_panel > this.options.max_panels) {
                this.set_current_panel(this.options.max_panels);
            }
            this.draw();
        }
    },
    destroy: function () {
        this.prev_el.removeEvents();
        this.next_el.removeEvents();
        this.prev_el.destroy();
        this.next_el.destroy();
        this.prev_el = null;
        this.next_el = null;
        this.panel_dots.destroy();
        this.panel_dots = null;
    }
});